/* u1 coffee — inner page behaviour: quantity steppers, cart auto-update,
   product page variant/price/image switching and add to cart.
   Every form still works without JavaScript (plain POST to Shopify). */
(() => {
  const root = window.Shopify?.routes?.root || '/';

  /* Quantity steppers: <div data-u1-step> button[data-step] + input */
  document.querySelectorAll('[data-u1-step]').forEach((box) => {
    const input = box.querySelector('input');
    if (!input) return;
    box.querySelectorAll('[data-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const min = Number(input.min || 0);
        const next = Math.max(min, (Number(input.value) || 0) + Number(btn.dataset.step));
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Cart: submit the form when a quantity changes */
  const cartForm = document.querySelector('[data-u1-cart-form]');
  if (cartForm) {
    let t;
    cartForm.addEventListener('change', (e) => {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(() => cartForm.submit(), 450);
    });
  }

  /* Product page */
  const form = document.querySelector('[data-u1-pform]');
  if (!form) return;
  const priceEl = document.querySelector('[data-u1-price]');
  const compareEl = document.querySelector('[data-u1-compare]');
  const mainImg = document.querySelector('[data-u1-main] img');
  const thumbs = [...document.querySelectorAll('[data-u1-thumb]')];
  const addBtn = form.querySelector('[data-u1-add]');
  const status = form.querySelector('[data-u1-status]');

  const showImage = (src, srcset, thumb) => {
    if (!mainImg || !src) return;
    mainImg.removeAttribute('srcset');
    mainImg.src = src;
    if (srcset) mainImg.srcset = srcset;
    thumbs.forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
  };
  thumbs.forEach((t) => t.addEventListener('click', () => showImage(t.dataset.src, t.dataset.srcset, t)));

  form.querySelectorAll('input[name="id"][type="radio"]').forEach((radio) => {
    radio.addEventListener('change', () => {
      if (priceEl) priceEl.textContent = radio.dataset.price;
      if (compareEl) {
        compareEl.textContent = radio.dataset.compare || '';
        compareEl.hidden = !radio.dataset.compare;
      }
      if (addBtn) {
        const ok = radio.dataset.available === 'true';
        addBtn.disabled = !ok;
        addBtn.textContent = ok ? addBtn.dataset.labelAdd : addBtn.dataset.labelSold;
      }
      if (radio.dataset.image) {
        const match = thumbs.find((t) => t.dataset.mediaId === radio.dataset.mediaId);
        showImage(radio.dataset.image, '', match);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      window.history.replaceState({}, '', url);
    });
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const fd = new FormData(form);
    addBtn.disabled = true;
    status.textContent = addBtn.dataset.labelAdding;
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }] }),
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.description || body.message || 'Error');
      status.innerHTML = '';
      status.append(document.createTextNode(`${addBtn.dataset.labelAdded} `));
      const a = document.createElement('a');
      a.href = `${root}cart`;
      a.textContent = addBtn.dataset.labelView;
      status.appendChild(a);
      const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
      document.querySelectorAll('[data-u1-cart-count]').forEach((el) => {
        el.textContent = String(cart.item_count);
        el.hidden = cart.item_count === 0;
      });
    } catch (err) {
      status.textContent = err.message;
    } finally {
      addBtn.disabled = false;
    }
  });
})();
